import cn from "classnames";
import { Country } from "types/country.types";
import { getCountryFlagUrl } from "utils/url.utils";
import { ArrowDownIcon } from "../Icons";
import { Loader } from "../Loader/Loader";
import style from "./PhoneCode.module.scss";

type PhoneCodeProps = {
  countryData: Country;
  isOpenList: boolean;
  setIsOpenList: (value: boolean) => void;
  isCountryLoading: boolean;
  disabled?: boolean;
};

export const PhoneCode = ({
  countryData,
  isOpenList,
  setIsOpenList,
  isCountryLoading,
  disabled = false,
}: PhoneCodeProps) => {
  const flagSrc = getCountryFlagUrl(countryData.countryCode);
  return (
    <>
      {isCountryLoading ? (
        <Loader className={style.loader} />
      ) : (
        <div
          onClick={() => {
            if (disabled) return;
            setIsOpenList(!isOpenList);
          }}
          className={cn(style.phoneCode, { [style.phoneCodeDisabled]: disabled })}
        >
          <img className={style.phoneCodeFlag} src={flagSrc} alt="flagIcon" />
          <input
            readOnly
            type="text"
            value={countryData?.iso || ""}
            className={cn(style.phoneCodeInput, { [style.phoneCodeInputDisabled]: disabled })}
          />
          <ArrowDownIcon
            className={cn(
              style.openListIcon,
              { [style.openListIconDisabled]: disabled },
              { [style.openListIconActive]: isOpenList }
            )}
          />
        </div>
      )}
    </>
  );
};
